// Buy it now: the button submits the native product form to /cart/add with return_to=/checkout.
// This guard stops a second click from adding the item twice while the page is navigating to checkout,
// and resets the button if the shopper comes back with the browser's back button.
if (!window.__sBuyNowGuard) {
  window.__sBuyNowGuard = true;

  document.addEventListener('submit', (event) => {
    const button = event.submitter;
    if (!(button instanceof HTMLElement) || !button.matches('[data-buy-now]')) return;

    if (button.getAttribute('aria-busy') === 'true') {
      event.preventDefault();
      return;
    }
    button.setAttribute('aria-busy', 'true');
  });

  window.addEventListener('pageshow', () => {
    for (const button of document.querySelectorAll('[data-buy-now][aria-busy="true"]')) {
      button.removeAttribute('aria-busy');
    }
  });
}
